import { Classified } from '../../rest/types/Classified'
import { AdsShareSocialNetworksProps } from '../../components/AdsShareSocialNetworks'

export function ClassifiedShareSocialNetworkTransformer({
  classified,
  t,
}: {
  classified: Classified
  t: any
}): AdsShareSocialNetworksProps | undefined {
  return classified
    ? {
        title: t('ads_share_social_networks_title'),
        urlToShare:
          typeof window !== 'undefined'
            ? window.location.href
            : t('ads_share_social_networks_default_share_url'),
        titleSharedPage: classified?.title ?? '',
      }
    : undefined
}
